import Vue from 'vue'
import Router from 'vue-router'
// import hello from '@/components/HelloWorld'
import main from '@/components/main'
import home from '@/components/home' // 首页
import product from '@/components/product' // 产品中心
import productDetail from '@/components/product-detail' // 产品中心-产品详情
import productDemo from '@/components/product-demo' // 产品中心-案例/方案详情
import news from '@/components/news' // 新闻动态
import newsDetail from '@/components/news-detail' // 新闻动态-新闻详情
import newsTips from '@/components/news-tips' // 新闻动态-标签选择
import contact from '@/components/contact' // 联系我们
import aboutus from '@/components/aboutus' // 关于我们
// import recruit from '@/components/recruit' // 人才招聘
import recruitJoin from '@/components/recruit-join' // 人才照片-加入我们
import recruitJoinDetail from '@/components/recruit-join-detail' // 新闻动态-加入我们-职位详情

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: main,
      children: [
        {
          path: '/',
          name: 'home',
          component: home
        },
        {
          path: 'product',
          name: 'product',
          component: product
        },
        {
          path: 'productDetail',
          name: 'productDetail',
          component: productDetail
        },
        {
          path: 'productDemo',
          name: 'productDemo',
          component: productDemo
        },
        {
          path: 'news',
          name: 'news',
          component: news
        },
        {
          path: 'newsDetail',
          name: 'newsDetail',
          component: newsDetail
        },
        {
          path: 'newsTips',
          name: 'newsTips',
          component: newsTips
        },
        {
          path: 'contact',
          name: 'contact',
          component: contact
        },
        {
          path: 'aboutus',
          name: 'aboutus',
          component: aboutus
        },
        // {
        //   path: 'recruit',
        //   name: 'recruit',
        //   component: recruit
        // },
        {
          path: 'recruit',
          name: 'recruit',
          component: recruitJoin
        },
        {
          path: 'recruitJoinDetail',
          name: 'recruitJoinDetail',
          component: recruitJoinDetail
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js